<c-search-box v-bind:size="size" @submit="doSearch"></c-search-box>